<template>
  <v-container>
    <div
      class="display-2 mb-7 mt-5 font-weight-thin"
      color="primary"
    >{{$tc('entities.version.title',2)}}</div>
    <alert-box v-model="alert.alerts" :type="alert.type"></alert-box>
    <versionFormOffline v-model="teste" />
    <!-- <selectList
      :apiController="apiController"
      :idParamName="idParamName"
      :getAllByIdParam="getAllByIdParam"
      :accessConfirm="$access.version.edit"
      :accessDelete="$access.version.delete"
      :selectLabel="$t('entities.version.props.code')"
    />-->
    <btn-a rounded color="primary" @click="editItem" :access="$access.version.edit">
      <v-icon>mdi-plus</v-icon>
    </btn-a>
    <table-grid
      :headers="headers"
      :items="items"
      :loading="loadingTable"
      :loadingAction="loadingDialog"
      :actions="actions"
      :page="pagination.page"
      :pageLength="lengthPaginationComp"
       @input="pagination.page = $event"
          @search="searchTable"
    />

    <dialog-d
      ref="dialogEdit"
      :title="$tc('entities.version.title')"
      :deleteButton="itemSelected && itemSelected.id"
      @confirm="saveItem(itemSelected,$refs.form.isValid())"
      @delete="deleteItem(itemSelected,true)"
      :loading="loadingDialog"
      :accessConfirm="$access.version.edit"
      :accessDelete="$access.version.delete"
      :alert="form.alert"
    >
      <versionForm ref="form" v-model="itemSelected" />
    </dialog-d>
  </v-container>
</template>

<script>
import versionService from "@/services/versionService"
import versionForm from "../components/forms/versions/versionForm";
import versionFormOffline from "../components/forms/versions/versionFormOffline";
// import selectList from "@/components/selectLists/selectList";
import pageListMixing from "../mixins/pageLists/pageListMixing.js";

export default {
  mixins: [pageListMixing],
  components: { versionForm, versionFormOffline },

  data() {
    return {
      teste: [],
      apiController: "version",
      entityService: versionService,
      searchFields:["code","description"],
      idParamName: "itemId",
      getAllByIdParam: true,
      headers: [
        {
          text: this.$t("entities.version.props.code"),
          align: "left",
          sortable: false,
          value: "code"
        },
        {
          text: this.$t("entities.version.props.description"),
          align: "left",
          sortable: false,
          value: "description"
        },

        {
          text: this.$t("table.actions"),
          value: "action",
          sortable: false,
          align: "right"
        }
      ],
      actions: [
        {
          text: this.$t("edit"),
          icon: "mdi-pencil",
          handle: this.editItem,
          access: [this.$access.version.edit, this.$access.version.show]
        },
        {
          text: this.$t("delete"),
          icon: "mdi-delete",
          handle: this.deleteItem,
          access: this.$access.version.delete
        }
      ]
    };
  },
  methods: {
    clickItemSelect(row) {
      this.$parent.$emit("clickTeste", row);
      // this.testeItems = [row];
      // this.teste = row;
      //this.$refs.dialogSelect.open();
    },
    clickSelect() {
      this.$refs.dialogSelect.open();
    },
    async getModelDefault() {
      return {
        code: await this.getAutoInc(this.apiController),
        description: "",
        stages: [],
        itemId: this.$route.params.itemId
      };
    }
  },
  async mounted() {
    await this.getItems();
  }
};
</script>